import { render, staticRenderFns } from "./RatesWeightDetails.vue?vue&type=template&id=f44801d2&scoped=true&"
import script from "./RatesWeightDetails.vue?vue&type=script&lang=js&"
export * from "./RatesWeightDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesWeightDetails.vue?vue&type=style&index=0&id=f44801d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44801d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f44801d2')) {
      api.createRecord('f44801d2', component.options)
    } else {
      api.reload('f44801d2', component.options)
    }
    module.hot.accept("./RatesWeightDetails.vue?vue&type=template&id=f44801d2&scoped=true&", function () {
      api.rerender('f44801d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesWeightDetails.vue"
export default component.exports